import { render } from "./InspectionRestart.vue?vue&type=template&id=471094fa"
import script from "./InspectionRestart.vue?vue&type=script&lang=js"
export * from "./InspectionRestart.vue?vue&type=script&lang=js"

import exportComponent from "/workspace/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__